const SERVICE_STATUS = {
    RESERVED: 'reserved',
    IN: 'in',
    OUT: 'out'
};
export const CALC_MODE = {
    CALC_MODE_CLIENT: 10,
    CALC_MODE_AGENCY: 20,
    CALC_MODE_PARKCLOUD: 21,
};
export class Reservation {
    get isCheckIn() {
        return this.serviceStatus === SERVICE_STATUS.RESERVED;
    }
    get isCheckOut() {
        return this.serviceStatus === SERVICE_STATUS.IN;
    }
}
//# sourceMappingURL=reservation.js.map